import React, { useEffect, useState } from 'react'
import { FiUpload } from 'react-icons/fi'
import { FaCloudUploadAlt, FaSpinner } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { onKycUpdate } from '../../../Redux/Actions/AuthActions';
import { setAlert } from '../../../Redux/Actions/AlertActions';
import AadharFront from "../../../images/aadhar-card-front.png"
import AadharBack from "../../../images/aadhar-back-img.png"
import Pancard from "../../../images/pan-card-img.webp"
import { onKycUpdateCreatorAdmin } from '../../../Redux/Actions/AdminDashboardActions';
import { ScrollPanel } from 'primereact/scrollpanel';
import DashboardFooter from '../../Common/DashboardFooter';


const AdminKycTasker = (props) => {
    const dispatch = useDispatch()

    const kyc = props?.data?.kyc
    const id = props?.data?.id
    const [loader, setLoader] = useState({
        fetch: false,
        update: false
    })
    const [selectType, setSelectType] = useState('')
    const [aadhar_card_frontUrl, setAadhar_card_frontUrl] = useState(null);
    const [aadhar_card_backUrl, setAadhar_card_backUrl] = useState(null);
    const [pan_cardUrl, setPan_cardUrl] = useState(null);




    const onCompleted = (url, type) => {
        if (type === "pan_card") {
            setPan_cardUrl(url)
        } else if (type === "aadhar_card_front") {
            setAadhar_card_frontUrl(url)
        } else {
            setAadhar_card_backUrl(url)
        }
    }
    const handleFileChange = (file, type) => {
        setSelectType(type)


        if (file?.size > 200 * 1024 * 1024) {

            dispatch(setAlert("File size exceeds 200MB. Please upload a smaller file.", "danger"));
            return;
        }
        if (file) {
            setLoader({
                ...loader,
                update: true
            })
            const formData = new FormData();
            formData.append(`type`, type)
            formData.append(`image`, file);
            formData.append(`id`, id)
            dispatch(onKycUpdateCreatorAdmin(formData, loader, setLoader, onCompleted))


        }
    };
    const handleDrop = (e, type) => {
        e.preventDefault();
        const files = e.dataTransfer.files[0];

        handleFileChange(files, type)

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };
    useEffect(() => {
        setAadhar_card_frontUrl(kyc?.aadhar_card_front);
        setAadhar_card_backUrl(kyc?.aadhar_card_back);
        setPan_cardUrl(kyc?.pan_card);
    }, [])

    return (
        <div>
            <ScrollPanel className="custombar2 content-area manage-users">
                <div className='account-block mb-5 mt-3'>
                    <div className="submission_wrap submission_bg py-4" style={{ background: "unset" }}>

                        <div className="row align-items-center  mb-2 mb-md-5">
                            <div className="col-lg-6 col-sm-7 col-md-7 mb-4">
                                <h3 className='mb-3' style={{ fontSize: "18px" }}>Pan card</h3>
                                <div className=" create_upload mt-3 mb-3 mb-lg-4"
                                    onDragOver={(e) => handleDragOver(e)}
                                    onDrop={(e) => handleDrop(e, "pan_card")}

                                >
                                    <FaCloudUploadAlt
                                        style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />
                                    <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                        Choose a file or drag & drop it here
                                    </span>

                                    <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                        onChange={(e) => handleFileChange(e.target.files[0], "pan_card")}

                                        style={{ cursor: "pointer" }}
                                    />

                                </div>
                            </div>
                            <div className='col-lg-3 col-sm-5 col-md-4 m-auto mb-4'>
                                <div className='account-block my-account-block d-flex justify-content-center'>
                                    {selectType === "pan_card" && loader.update ? <div className='d-flex justify-content-center align-items-center' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> : <img src={pan_cardUrl ? pan_cardUrl : Pancard} alt="" className='img-fluid' />}
                                </div>
                            </div>

                        </div>
                        <div className='row align-items-center mt-4 '>

                            <div className="col-lg-6 col-sm-7 col-md-7">
                                <h3 style={{ fontSize: "18px" }}>Aadhar card</h3>


                                <div className=" create_upload mt-3 mb-3"
                                    onDragOver={(e) => handleDragOver(e)}
                                    onDrop={(e) => handleDrop(e, "aadhar_card_front")}
                                    style={{ cursor: "pointer", opacity: 1 }}
                                >
                                    <FaCloudUploadAlt
                                        style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />
                                    <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                        Choose a file or drag & drop it here
                                    </span>

                                    <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                        onChange={(e) => handleFileChange(e.target.files[0], "aadhar_card_front")}

                                        style={{ cursor: "pointer" }}
                                    />

                                </div>
                                <div className=" create_upload mb-3 mb-lg-0"
                                    onDragOver={(e) => handleDragOver(e)}
                                    onDrop={(e) => handleDrop(e, "aadhar_card_back")}
                                    style={{ cursor: "pointer", opacity: 1 }}
                                >
                                    <FaCloudUploadAlt
                                        style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />
                                    <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                        Choose a file or drag & drop it here
                                    </span>

                                    <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                        onChange={(e) => handleFileChange(e.target.files[0], "aadhar_card_back")}

                                        style={{ cursor: "pointer" }}
                                    />

                                </div>
                            </div>
                            <div className='col-lg-3 col-sm-5 col-md-4 m-auto'>
                                <div className='account-block my-account-block d-flex justify-content-center'>
                                    {selectType === "aadhar_card_front" && loader.update ? <div className='d-flex justify-content-center align-items-center' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> : <img src={aadhar_card_frontUrl ? aadhar_card_frontUrl : AadharFront} alt="" className='img-fluid' />}
                                </div>

                                <div className='account-block mt-4 my-account-block d-flex justify-content-center'>
                                    {selectType === "aadhar_card_back" && loader.update ? <div className='d-flex justify-content-center align-items-center' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> : <img src={aadhar_card_backUrl ? aadhar_card_backUrl : AadharBack} alt="" className='img-fluid' />}

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </ScrollPanel>
            {/* <DashboardFooter /> */}
        </div>
    )
}

export default AdminKycTasker
